import router from './router'
import {getAccount, getPasswordException} from '@/utils/auth'
import {getLoginId} from '@/utils/loginId'
import store from './store'

const whiteList = ['/login', '/redirectlogin']// 白名单菜单
router.beforeEach((to, from, next) => {
  if (getAccount()) {
    if (whiteList.includes(to.path)) {
      next()
    } else if (['PX0001', 'PX0002'].includes(getPasswordException())) {
      next({path: '/login'})
    } else if (to.path === '/') {
      store.dispatch('GenerateUserInfo')
      next()
    } else {
      if (!store.getters.appisinit) {
        store.dispatch('GetMenuTree', to.path).then(() => {
          store.dispatch('GenerateRoutes', {menus: store.getters.menus, path: to.path}).then((menusInfo) => {
            router.addRoutes(store.getters.addRouters)
            store.dispatch('SetAppInfo', menusInfo)
            next({ ...to, replace: true })
          })
        }).catch(() => {
          store.dispatch('FedLogOut')
        })
      } else {
        const router = store.getters.addRouters.filter(item => item.url === to.path)
        if (router.length !== 0) {
          store.dispatch('GenerateCurrentRoutes', {menus: store.getters.menus, path: to.path}).then((menusInfo) => {
            store.dispatch('SetAppInfo', menusInfo)
            next()
          })
        } else {
          next()
        }
      }
    }
  } else {
    const iss = whiteList.filter(item => {
      let re = new RegExp('^' + item + '(?:/((?:[^/]+?)))?(?:/(?=$))?$', 'i')
      return re.test(to.path)
    })
    if (iss.length > 0) { // 在免登录白名单，直接进入
      next()
    } else {
      const loginId = getLoginId()
      next('/login' + (loginId ? `/${loginId}` : '')) // 否则全部重定向到登录页
      // next('/login')
      // next()
    }
  }
})



// WEBPACK FOOTER //
// ./src/permission.js